import React from 'react';

import fetch from './../fetch';

import utils from './../../utils';

import {Modal, message} from 'antd';

const Indexes = [
    "A", 'B', 'C', 'D', 'E', 'F', 'G',
    'H', 'I', 'J', 'K', 'L', 'M', 'N',
    'O', 'P', 'Q', 'R', 'S', 'T', 'U',
    'V', 'W', 'X', 'Y', 'Z'
];

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const headers = utils.columns([

    {type: 'selection'},
    {
        key:'$index', 
        label: '序号'
    },
    {
        key:'subName', 
        width: 200, 
        label: '测评依据'
    },
    {
        key:'subDetail', 
        label: '测评结果', 
        width: 240, 
        render: (data, column) => {
            if(column.subType == 1) {
                return (
                    <ol className="upper-alpha">
                        {
                            data.map((d, i) => (
                                <li>
                                    选项{Indexes[i]}：{d.label}
                                </li>
                            ))
                        }
                    </ol>
                )
            } else if(column.subType == 'text') {
                return "";
            }
        }
    },
    {
        key: 'subType', 
        label: '题目类型', 
        render: (type) => {
            if(type === 1) {
                return '单选';
            } else if(type === 2) {
                return '填空';
            }
        } 
    }
]);

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('course/assess/item/get/'+ id, {})
    .then(response => response.payload.data)
    .catch(error => {
        // console.log('error');
    });
}

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    const targetId = keywords.targetId;
    let params = []
    if(keywords['sort'] !== '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    let promise;
    if(!targetId) {
        promise = new Promise((resolve, reject) => {
            resolve({
                code: 200,
                payload: {
                    data: {
                        dataList: [],
                        total: 0,
                        pageIndex: keywords.pageNum,
                        pageSize: keywords.pageSize,
                    }
                }
            })
        })
    } else {
        promise = fetch.get(`course/assess/item/list/${targetId}?` + params.join('&'));
    }
    return promise.then(response => {
        return response.payload.data;
    })
    .then(data => {
        const list = (Object.assign({
            result: (data.dataList || []).map(item => {
                return Object.assign({}, item, {
                    height: (item.subDetail || []).length * 30
                })
            }),
            selects: (data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
                height: (d.subDetail || []).length * 30
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data.dataList || []).length ? '' : '暂无数据...'
        }));

        return list;
    });
}

/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('course/assess/item/insert', data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '测评依据添加成功!',
                content: (
                    <div>
                        <p>点击确认后，将自动跳转到测评依据管理页面！</p>
                    </div>
                ),
                onOk() {
                },
                okText:"确认",
            });
        }
    });
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('course/assess/item/update/' + id, data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '测评依据更新成功!',
                content: (
                    <div>
                        <p>点击确认后，将自动跳转到测评依据管理页面！</p>
                    </div>
                ),
                onOk() {
                    
                },
                okText:"确认",
            });
        }
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('course/assess/item/delete', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = () => {
    if(DataGrid.selections.length === 0) {
        Modal.warn({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText:"确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections).then(response => {
                    if(response.code === 200) {
                        message.success(response.message);
                        DataGrid.selections = [];
                        DataGrid.refresh();
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method getSelection
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const getSelection = () => {
    return DataGrid.selections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    
};

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if(DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.warn({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText:"确认",
        });
    } else {
        redirect('/update/'+ DataGrid.selections[0]);
    }
}

export default {
    querySearchById,
    insert,
    update,
    querySearch,
    remove,
    headers,
    onSelect,
    batchRemove,
    setRefresh,
    batchUpdate,
    getSelection,
    redirect
}